import { render, staticRenderFns } from "./publish_sidebar.vue?vue&type=template&id=7f80c284&scoped=true&"
import script from "./publish_sidebar.vue?vue&type=script&lang=js&"
export * from "./publish_sidebar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f80c284",
  null
  
)

export default component.exports